// ---
import React from "react";
import {connect} from "react-redux";
import {FieldArray, formValueSelector, reduxForm} from "redux-form";
import {ff, form, Icon} from "@mc/mc-legacy";
import {Col, Row} from "@mc/ui-v3";
import "./ChangeApproversForm.scss";
import {Button} from "@mc/react-core";


const Form = form.Form;
const FormBody = form.FormBody;
const FormActions = form.FormActions;

const validate = (formData) => {
    const errors = {} as any;
    if (formData && formData.signers) {
        const signers = formData.signers;
        signers.forEach((signer, i) => {
            if (signer.pracovnikId == null && i > 0) {
                if (!errors.signers) {
                    errors.signers = [];
                }
                errors.signers[i] = {pracovnikId: "Je třeba vyplnit podepisujícího"};
            }
        });
    }
    return errors;
};

/**
 * Formulář založení schvalujících.
 */
class CreateSignersForm extends React.Component {
    static formName = "CreateSignersForm";

    constructor(props) {
        super(props);
    }

    renderSigners = ({fields}) => {
        const {submitting, podepisujici} = this.props;

        return (
            <div>
                {fields.map((field, index) => {
                    const add = (index + 1) === fields.length;
                    const removeSigner = fields.length == 1;
                    return <Row noGutters className="approver" key={index}>
                        <Col>
                            <Row>
                                <Col>
                                    <ff.Autocomplete
                                        name={field + ".pracovnikId"}
                                        items={podepisujici}
                                        useIdAsValue={true}
                                        label={false}
                                        renderItemContent={(item, name) => {
                                            if (name && name.length > 0) {
                                                return (
                                                    <span title={item.title ? item.title : ""} className="item-text">
                                              {name}
                                            </span>
                                                );
                                            } else {
                                                return <span className="item-text">&nbsp;</span>;
                                            }
                                        }}
                                        disabled={submitting}
                                    />
                                </Col>
                                <Col>
                                    <ff.String label="" placeholder={'Popis k podepisujícímu'} name={field + ".signerDescription"}
                                               disabled={submitting}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs="auto">
                            {!removeSigner && <Button
                                className="btn-transparent p-0 ml-1"
                                title="Odebrat"
                                onClick={() => {
                                    fields.remove(index)
                                }}
                            >
                                <Icon icon={"trash-o"}/>
                            </Button>}
                            {add && <Button
                                className="btn-transparent p-0 ml-1"
                                title="Přidat podepisujícího"
                                onClick={() => {
                                    fields.push({pracovnikId: null, signerDescription: null})
                                }}>
                                <Icon icon={"plus-square-o"}/>
                            </Button>}
                        </Col>
                    </Row>
                })}
            </div>)
    }

    render() {
        const {onClose, handleSubmit, submitting} = this.props;
        return (
            <Form className="change-approvers-form" onSubmit={handleSubmit}>
                <FormBody>
                    <FieldArray name="signers" component={this.renderSigners}/>
                </FormBody>
                <FormActions onClose={onClose} disabled={submitting} submitButton="Uložit" cancelButton/>
            </Form>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector(CreateSignersForm.formName);
    return {signers: selector(state, "signers")};
}

const reduxFormObj = reduxForm({
    form: CreateSignersForm.formName,
    validate: validate,
})(CreateSignersForm);
export default connect(mapStateToProps)(reduxFormObj);
